// Load Styles
import '../scss/main.scss';

import '../../node_modules/slick-carousel/slick/slick.css';

import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/solid'
import '@fortawesome/fontawesome-free/js/regular'
import '@fortawesome/fontawesome-free/js/brands'
import '@fancyapps/ui/src/Fancybox/Fancybox';
import "@fancyapps/ui/dist/fancybox.css";
// import AOS from 'aos';
// import 'aos/dist/aos.css';

// Load Bootstrap init

global.$ = require("jquery");
global.jQuery = global.$;
import { initBootstrap } from "./bootstrap";


// initBootstrap({
//     tooltip: true,
//     popover: true,
//     toasts: true,
// });


require('../../node_modules/slick-carousel/slick/slick.min.js');
require('../../node_modules/isotope-layout/dist/isotope.pkgd.min.js');

const WOW = require('wowjs');

window.wow = new WOW.WOW({
    live: false
});
// AOS.init({
//   once: true,
//     disable: function() {
//       var maxWidth = 800;
//       return window.innerWidth < maxWidth;
//     }
// });
require('./custom.js');

